import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode, Ref } from 'react'
import styles from './button.module.css'
import { cx } from './cx'

export type ButtonVariant = 'cta' | 'ink' | 'secondary' | 'danger' | 'text'

interface VariantProps {
  variant?: ButtonVariant
  /** Растянуть вторичную кнопку на всю ширину (CTA всегда во всю ширину). */
  block?: boolean
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps & { ref?: Ref<HTMLButtonElement> }

/** Кнопки «Поп»: CTA одна на экран, на оранжевом только тёмный текст. */
export function Button({ variant = 'cta', block = false, className, type = 'button', ...rest }: ButtonProps) {
  return <button type={type} className={cx(styles.base, styles[variant], block && styles.block, className)} {...rest} />
}

export type ButtonLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & VariantProps & { ref?: Ref<HTMLAnchorElement> }

/** Та же кнопка ссылкой: для `createLink` роутера и внешних адресов (бот в Telegram). */
export function ButtonLink({ variant = 'cta', block = false, className, ...rest }: ButtonLinkProps) {
  return <a className={cx(styles.base, styles[variant], block && styles.block, className)} {...rest} />
}

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Без подписи кнопке обязательно нужно имя для скринридера. */
  'aria-label': string
  children: ReactNode
}

export function IconButton({ className, type = 'button', ...rest }: IconButtonProps) {
  return <button type={type} className={cx(styles.icon, className)} {...rest} />
}
